<div class="breadcrumb">
    <div class="container">
        <a routerLink="/">Home</a> > {{ 'Lista de arquivos em SFTP' | translate}}
    </div>
</div>

<main class="container">
    <h1>{{ 'Lista de arquivos em SFTP' | translate}}</h1>

    <div class="filtros">
        <div class="filtro">
            <label for="pais">{{ 'País' | translate}}</label>
            <select id="pais" [(ngModel)]="filtro.pais">
                <option value="">{{ 'Selecione' | translate}}</option>
                <option *ngFor="let pais of listaPaises" [value]="pais.name">{{pais.name}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="ano">{{ 'Ano' | translate}}</label>
            <input type="text" id="ano" maxlength="4" [(ngModel)]="filtro.ano" />
        </div>
        <div class="filtro">
            <label for="mes">{{ 'Mês' | translate}}</label>
            <select id="mes" [(ngModel)]="filtro.mes">
                <option *ngFor="let mes of meses" [value]="mes">{{mes}}</option>
            </select>
        </div>
        <!-- Incluir subpastas desativado (varredura recursiva muito lenta). Para reativar, descomentar aqui e o aviso abaixo.
        <div class="filtro">
            <label for="subpastas">{{ 'Incluir subpastas' | translate}}</label>
            <input type="checkbox" id="subpastas" [(ngModel)]="filtro.incluirSubpastas" />
        </div>
        -->
        <div class="filtro">
            <label for="f_provider">{{ 'Provedor' | translate}}</label>
            <select id="f_provider" [(ngModel)]="filtroLocal.provider" (ngModelChange)="aplicarFiltroLocal()" [disabled]="!resultado">
                <option value="">{{ 'Todos' | translate}}</option>
                <option *ngFor="let v of opcoesProvider" [value]="v">{{v}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="f_envio">{{ 'Envio' | translate}}</label>
            <select id="f_envio" [(ngModel)]="filtroLocal.envio" (ngModelChange)="aplicarFiltroLocal()" [disabled]="!resultado">
                <option value="">{{ 'Todos' | translate}}</option>
                <option *ngFor="let v of opcoesEnvio" [value]="v">{{v}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="f_pdv">{{ 'PDV' | translate}}</label>
            <select id="f_pdv" [(ngModel)]="filtroLocal.pdv" (ngModelChange)="aplicarFiltroLocal()" [disabled]="!resultado">
                <option value="">{{ 'Todos' | translate}}</option>
                <option *ngFor="let v of opcoesPdv" [value]="v">{{v}}</option>
            </select>
        </div>
        <div class="filtro-acoes">
            <button (click)="consultar()" class="red_button" [disabled]="!podeConsultar">{{ 'Consultar' | translate }}</button>
            <button (click)="limparFiltro()" class="red_button">{{ 'Limpar' | translate}}</button>
            <button (click)="exportarCsv()" class="red_button" [disabled]="!resultado">{{ 'Exportar CSV' | translate }}</button>
        </div>
    </div>

    <!--
    <p class="aviso" *ngIf="filtro.incluirSubpastas">
        {{ 'Incluir subpastas pode levar vários minutos.' | translate}}
    </p>
    -->
    <p class="erro" *ngIf="erro">{{erro}}</p>

    <div class="resumo" *ngIf="resultado">
        <div><strong>{{ 'Data/Hora da consulta' | translate}}:</strong> {{resultado.dataHora | date:'dd/MM/yyyy HH:mm:ss'}}</div>
        <div><strong>{{ 'Zips' | translate}}:</strong> {{resumo.zips}}</div>
        <div><strong>{{ 'Imagens' | translate}}:</strong> {{resumo.imagens}}</div>
        <div><strong>{{ 'Outros arquivos' | translate}}:</strong> {{resumo.outros}}</div>
        <div><strong>{{ 'Total de arquivos' | translate}}:</strong> {{resumo.total}}</div>
        <div><strong>{{ 'Erros' | translate}}:</strong> {{resumo.erros}}</div>
    </div>

    <table border="0" cellpadding="0" cellspacing="0" *ngIf="resultado">
        <thead>
            <tr>
                <th>{{ 'Data/Hora' | translate}}</th>
                <th>{{ 'Arquivo (zip)' | translate}}</th>
                <!-- <th>{{ 'Subpasta' | translate}}</th> -->
                <th>{{ 'Provedor' | translate}}</th>
                <th>{{ 'Envio' | translate}}</th>
                <th>{{ 'Cidade' | translate}}</th>
                <th>{{ 'Farmácia' | translate}}</th>
                <th>{{ 'PDV' | translate}}</th>
                <th>{{ 'Tamanho (MB)' | translate}}</th>
                <th>{{ 'Imagens' | translate}}</th>
                <th>{{ 'Outros' | translate}}</th>
                <th>{{ 'Total' | translate}}</th>
                <th>{{ 'Erro' | translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of itens | paginate: { itemsPerPage: pageSize, currentPage: currentPage }" [class.linha-erro]="item.erro" [title]="item.caminhoCompleto">
                <td>{{item.dataHora | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                <td>{{item.zipName}}</td>
                <!-- <td>{{item.subpasta}}</td> -->
                <td>{{item.provider}}</td>
                <td>{{item.envio}}</td>
                <td>{{item.codigoCidade}}</td>
                <td>{{item.codigoFarmacia}}</td>
                <td>{{item.nomePdv}}</td>
                <td>{{item.tamanhoMb | number:'1.2-2'}}</td>
                <td>{{item.imagens}}</td>
                <td>{{item.outrosArquivos}}</td>
                <td>{{item.totalArquivos}}</td>
                <td>{{item.erro}}</td>
            </tr>
            <tr *ngIf="itens.length === 0">
                <td colspan="12" class="text-center">{{ 'Nenhum zip encontrado.' | translate}}</td>
            </tr>
        </tbody>
    </table>

    <div class="text-center pagination" *ngIf="resultado">
        <div class="pagination-info">
            {{ 'Total de registros' | translate }}: {{ itens.length }}
        </div>
        <div class="pagination-controls">
            <pagination-controls (pageChange)="currentPage = $event" previousLabel="" nextLabel=""></pagination-controls>
        </div>
    </div>
</main>
